import { render, staticRenderFns } from "./ticket-dropdown-item.vue?vue&type=template&id=1b44fa1f&scoped=true"
import script from "./ticket-dropdown-item.vue?vue&type=script&lang=js"
export * from "./ticket-dropdown-item.vue?vue&type=script&lang=js"
import style0 from "./ticket-dropdown-item.vue?vue&type=style&index=0&id=1b44fa1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b44fa1f",
  null
  
)

export default component.exports